module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_vansbro-2f81bea08bb4ea17ceab68c7f4a9b096.png";